import { DescriptionsItemType } from 'antd/es/descriptions';
import { useTranslation } from 'translations/hooks';

import { GetPreviousPrintReportQuery } from 'generated/graphql';

type UseBuildExcavationAndBuildDescriptionItems = {
  previousReport: GetPreviousPrintReportQuery['shiftReport'][0] | undefined;
  averageExcavationPerRing: string | null;
  averageBuildPerRing: string | null;
};

export const useBuildExcavationAndBuildDescriptionItems = ({
  previousReport,
  averageExcavationPerRing,
  averageBuildPerRing,
}: UseBuildExcavationAndBuildDescriptionItems) => {
  const { t } = useTranslation();

  if (previousReport?.lastFinishedRing !== null) {
    const withPreviousReportItems = [
      {
        key: 'excavationPerRing',
        label: t('pages.print.excavationPerRing'),
        children: t('pages.print.ringPerMinute', {
          averageTime: averageExcavationPerRing,
          context: averageExcavationPerRing ? '' : 'unavailable',
        }),
        className: 'item',
        span: 3,
      },
      {
        key: 'buildPerRing',
        label: t('pages.print.buildPerRing'),
        children: t('pages.print.ringPerMinute', {
          averageTime: averageBuildPerRing,
          context: averageBuildPerRing ? '' : 'unavailable',
        }),
        className: 'item',
        span: 3,
      },
    ] satisfies DescriptionsItemType[];

    return withPreviousReportItems;
  }

  const withoutPreviousReportItems = [
    {
      key: 'excavationPerRing',
      label: t('pages.print.excavationPerRing'),
      children: t('pages.print.missingPreviousReport'),
      className: 'item',
      span: 3,
    },
    {
      key: 'buildPerRing',
      label: t('pages.print.buildPerRing'),
      children: t('pages.print.missingPreviousReport'),
      className: 'item',
      span: 3,
    },
  ] satisfies DescriptionsItemType[];

  return withoutPreviousReportItems;
};
